<script setup lang="ts">
import { useColorMode } from '@vueuse/core'
import { Toaster } from 'pejer/src/components/ui/toast'
import { onMounted } from 'vue'
// import Navbar from './components/Navbar/Navbar.vue'

const mode = useColorMode({ initialValue: 'light' })

onMounted(() => {
  mode.value = 'light'
})
</script>
<template>
  <div class="text-slate-700">
    <!-- <Navbar
      class="mt-[--topbar-height] h-[calc(100vh-var(--topbar-height))] shadow-lg"
      v-if="!$route.meta?.hideNavbar"
    />
    <NavbarTopBar
      v-if="!$route.meta?.hideNavbar"
      class="w-[--sidebar-closed-width] xl:w-[--sidebar-width]"
    /> -->
    <main>
      <RouterView v-slot="{ Component }">
        <!-- <KeepAlive :max="20"> -->
        <component :is="Component" />
        <!-- </KeepAlive> -->
      </RouterView>
    </main>
    <Toaster />
  </div>
</template>
